import {Select} from 'antd'
import {ProductAttributeType} from '../../tabs/ProductAttributes'
import React, {useContext} from 'react'
import {CatalogContext} from '../../../../../providers/CatalogProvider'

type ProductAttributeProductItemProps = {
    attr: ProductAttributeType
}

const ProductAttributeProductItem = ({attr}: ProductAttributeProductItemProps) => {
    const {requests, setAttributes, attributes} = useContext(CatalogContext)
    const {products} = requests

    const handleChangeValue: HandleChangeAttributeValue = (value) => {
        setAttributes(attributes.map(item => ({
            ...item,
            value: item.id === attr.id ? value : item.value,
            default_value: item.id === attr.id ? null : item.default_value,
            status: item.id === attr.id ? 'changed' : item.status,
        })))
    }

    const handleChangeDefaultValue: HandleChangeAttributeDefaultValue = (value) => {
        setAttributes(attributes.map(item => ({
            ...item,
            default_value: item.id === attr.id ? value : item.default_value,
            status: item.id === attr.id ? 'changed' : item.status,
        })))
    }

    return (
        <>
            <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder="Select Products"
                value={attr.value ? (attr.value as string | string[]) : null}
                onChange={handleChangeValue}>
                {products.map(item => {
                    return <Select.Option key={item.id} value={item.id.toString()}>
                        {item.name}
                    </Select.Option>
                })}
            </Select>

            <Select
                showSearch
                allowClear
                optionFilterProp="children"
                placeholder="Select Default Option"
                value={attr.default_value}
                onChange={handleChangeDefaultValue}>
                {products.map(item => {
                    if (item.id != attr.value) return
                    return (
                        <Select.Option key={item.id} value={item.id.toString()}>
                            {item.name}
                        </Select.Option>
                    )
                })}
            </Select>
        </>
    )
}

export default ProductAttributeProductItem

type HandleChangeAttributeValue = (value: string | string[]) => void
type HandleChangeAttributeDefaultValue = (value: string) => void
